import React from 'react'
import { number } from 'prop-types'

function FixedPricing({ width = 16, height = 24, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3335 7.30275C11.3335 6.83111 10.8571 6.5086 10.4192 6.68377L5.46179 8.66675H11.3335V7.30275ZM1.3335
        9.78473V10.0001V14V17.3334C1.3335 18.0698 1.93045 18.6667 2.66683 18.6667H13.3335C14.0699 18.6667 14.6668
        18.0698 14.6668 17.3334V10.0001C14.6668 9.2637 14.0699 8.66675 13.3335 8.66675H12.6668V7.30275C12.6668 5.88782
        11.2378 4.92031 9.92405 5.4458L2.17164 8.54676C1.66543 8.74925 1.3335 9.23952 1.3335 9.78473ZM10.6668
        12.0001V15.3334H12.0002V12.0001H10.6668Z"
        fill="#73ABF5"
      />
    </svg>
  )
}

FixedPricing.propTypes = {
  width: number,
  height: number,
}

export default FixedPricing
